import Layout from 'components/layout'
import Teamimage from 'components/equipe/teamImage'

export function l({ name, excerpt, image, isFun, setFun, floatingElements = null, children }) {
  return (
    <div className="bg-yellow-50">
      <Layout>
        <div className="md:h-[750px] grid gap-12 grid-cols-1 py-20 md:grid-cols-2 lg:gap-24 lg:px-4">
          <div className="relative w-full" style={{ paddingTop: '140%' }}>
            <div className="absolute right-0 top-0 w-full h-full object-cover overflow-hidden">
              <Teamimage work={image.work} fun={image.fun} withFun isFun={isFun} setFun={setFun} className="z-20" />
              {/* <Image layout="fill" src={image} className="absolute z-20 object-cover" /> */}
            </div>
            {floatingElements}
          </div>

          <div className="flex flex-col justify-center pt-12 lg:pr-28">
            <div>
              <h2 className="text-center font-serif text-5xl font-bold">{name}</h2>
              <p className="mt-4 text-center text-lg font-medium leading-snug">{excerpt}</p>
              <p className="mt-4 text-justify">{children}</p>

              <div className="flex justify-center mt-14">
                <Showfunbutton isFun={isFun} setFun={setFun} />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  )
}

export function r({ name, excerpt, image, isFun, setFun, floatingElements = null, children }) {
  return (
    <div className="">
      <Layout>
        <div className="md:h-[750px] grid gap-12 grid-cols-1 py-20 md:grid-cols-2 lg:gap-24 lg:px-4">
          <div className="relative w-full md:hidden" style={{ paddingTop: '140%' }}>
            <div className="absolute top-0 -my-12 w-full h-full object-cover overflow-hidden">
              <Teamimage work={image.work} fun={image.fun} withFun isFun={isFun} setFun={setFun} className="z-20" />
              {/* <Image layout="fill" src={image} className="absolute z-20 object-cover" /> */}
            </div>
            {floatingElements}
          </div>

          <div className="flex flex-col justify-center pt-12 md:pl-28">
            <div>
              <h2 className="text-center font-serif text-5xl font-bold">{name}</h2>
              <p className="mt-4 text-center text-lg font-medium leading-snug">{excerpt}</p>
              <p className="mt-4 text-justify">{children}</p>

              <div className="flex justify-center mt-14">
                <Showfunbutton isFun={isFun} setFun={setFun} />
              </div>
            </div>
          </div>

          <div className="relative hidden w-full md:block" style={{ paddingTop: '140%' }}>
            <div className="absolute top-0 w-full h-full object-cover overflow-hidden">
              <Teamimage work={image.work} fun={image.fun} withFun isFun={isFun} setFun={setFun} className="z-20" />
              {/* <Image layout="fill" src={image} className="absolute z-20 object-cover" /> */}
            </div>
            {floatingElements}
          </div>
        </div>
      </Layout>
    </div>
  )
}

const Showfunbutton = ({ isFun, setFun }) => {
  return (
    <button
      onClick={() => setFun((prev) => !prev)}
      className="inline-flex items-center justify-center w-12 h-12 border border-black rounded-full focus:outline-none focus:ring-black focus:ring-offset-2 focus:ring-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 34 34"
        className={`${
          isFun ? 'rotate-45 ease-out duration-200' : 'rotate-0 ease-in duration-200'
        } w-8 h-8 transform  transition-transform`}
        stroke="currentColor">
        <path strokeWidth={1.5} d="M32 17H17M17 17H2M17 17V2M17 17V32.5" />
      </svg>
    </button>
  )
}
